

export default class AgentService {
  private agentStatusMap = new Map();

  public initMessages(message: any[]) {
    this.clear();
    message.forEach((item) => {
      if (item.agentId && item.agentName) {
        this.agentStatusMap.set(item.id, {
          agentId: item.agentId,
          agentName: item.agentName,
        });
      }
    });
  }

  public clear() {
    this.agentStatusMap = new Map();
  }

  public get(messageId: string) {
    return this.agentStatusMap.get(messageId);
  }

  public has(messageId: string) {
    return this.agentStatusMap.has(messageId);
  }

  public set(messageId: string, agent: {
    agentId: string;
    agentName: string
  }) {
    return this.agentStatusMap.set(messageId, agent);
  }
}

export const agentService = new AgentService();
